<template>
    <div class="form-container">
        <!-- <div class="columns">
            <div class="column">
                <div id="weight-dimension-instructions">
                    <div class="instructions">
                        <p>{{ $t("Instructions") }}</p>
                        <button
                            class="button rounded-7 px-15"
                            @click="isOpen = !isOpen"
                            aria-controls="instructions"
                        >
                            {{ isOpen ? $t("Hide") : $t("Show") }}
                        </button>
                    </div>
                    <b-collapse
                        aria-id="instructions"
                        class="panel"
                        animation="slide"
                        :open.sync="isOpen"
                    >
                        <div class="instruction-body">
                            {{
                                $t(`Please make sure to use HEAVY DUTY boxes to protect
                            your shipment. If you are shipping from the United
                            States, you can buy your boxes through`)
                            }}
                            <a href="https://www.uline.com/" target="_blank"
                                >Uline.com</a
                            >
                            |
                            <a href="https://www.homedepot.com/" target="_blank"
                                >Homedepot.com</a
                            >
                            |
                            <a target="_blank" href="https://www.lowes.com/"
                                >Lowes.com</a
                            >
                            <br />
                            {{
                                $t(
                                    `It is necessary to disclose the accurate weight and dimensions to avoid overweight charges. And we have the right to hold your shipments until we receive the charges.`
                                )
                            }}
                        </div>
                    </b-collapse>
                </div>
            </div>
        </div> -->
        <div class="columns">
            <div class="column is-half">
                <div class="columns">
                    <div class="column">
                        <p id="form-title-top">{{ $t("Add your packages") }}</p>
                        <p class="hint">
                            {{ $t("Please write the numbers in English") }}
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <div class="columns">
            <div class="column is-full">
                <div class="columns contents">
                    <table class="table">
                        <tbody>
                            <tr
                                class="item"
                                style="display: flex"
                                v-for="(shipment, index) in shipping"
                                :key="index"
                            >
                                <!-- <div
                                    v-if="
                                        (shipment.measurement == 'metric' &&
                                            (shipment.weight > 65 ||
                                                shipment.length > 104 ||
                                                shipment.width > 104 ||
                                                shipment.height > 104)) ||
                                        (shipment.measurement == 'imperial' &&
                                            (shipment.weight > 143 ||
                                                shipment.length > 41 ||
                                                shipment.width > 41 ||
                                                shipment.height > 41))
                                    "
                                    class="oversizeMsg"
                                >
                                    <div
                                        class="msg"
                                        v-if="
                                            (shipment.measurement == 'metric' &&
                                                shipment.weight > 65) ||
                                            (shipment.measurement ==
                                                'imperial' &&
                                                shipment.weight > 143)
                                        "
                                    >
                                        {{
                                            $t(
                                                "You have overweight, 350 SAR will added to the final cost"
                                            )
                                        }}
                                    </div>
                                    <div
                                        class="msg"
                                        v-if="
                                            (shipment.measurement == 'metric' &&
                                                (shipment.length > 104 ||
                                                    shipment.width > 104 ||
                                                    shipment.height > 104)) ||
                                            (shipment.measurement ==
                                                'imperial' &&
                                                (shipment.length > 41 ||
                                                    shipment.width > 41 ||
                                                    shipment.height > 41))
                                        "
                                    >
                                        {{
                                            $t(
                                                "You have oversize, 350 SAR will added to the final cost"
                                            )
                                        }}
                                    </div>
                                </div> -->
                                <td style="width: 12%" class="shipment-type">
                                    <p>
                                        <span
                                            style="
                                                color: #4d4d4d;
                                                font-size: 2em;
                                                font-weight: bold;
                                            "
                                            >{{
                                                shipment.type == "box"
                                                    ? $t("Parcel")
                                                    : $t(shipment.type)
                                            }}</span
                                        >
                                        <!-- <span
                                            v-if="
                                                shipment.type == 'box' ||
                                                shipment.type == 'parcel'
                                            "
                                            style="
                                            display:block
                                            color: #4d4d4d;
                                            font-size: 14px;
                                        "
                                            >(
                                            {{ $t("Box, Bag, Flyer") }} )</span
                                        > -->

                                        <!-- <span
                                            v-else
                                            style="
                                            display:block
                                            color: #4d4d4d;
                                            font-size: 12px;
                                            margin: 0 5px
                                        "
                                            >({{ $t("Paper work only") }})</span
                                        > -->
                                    </p>
                                    <!-- <button
                    v-if="checkInMyList(shipment)"
                    @click="saveInList(shipment)"
                    class="button"
                    style="
                      width: 100px;
                      font-size: 12px;
                      height: 23px;
                      padding: 0px 30px;
                      margin-bottom: 10px;
                    "
                  >
                    {{ $t("Add to my list") }}
                  </button> -->
                                </td>
                                <!-- <td
                                    style="width: 14%"
                                    class="shipment-units grayed"
                                    :id="`units-${shipment.id}`"
                                >
                                    <div class="dimension-marker tooltip-ex">
                                        {{ $t("Unit") }}
                                    </div>
                                    <div class="form2-units" id="b-select">
                                        <b-select
                                            v-model="shipment.measurement"
                                            @input="packageUnit"
                                        >
                                            <option
                                                disabled
                                                style="opacity: 0.5"
                                                value
                                            >
                                                {{ $t("Unit") }}
                                            </option>
                                            <option value="metric">
                                                {{ $t("kg/cm") }}
                                            </option>
                                            <option value="imperial">
                                                {{ $t("lb/in") }}
                                            </option>
                                        </b-select>
                                    </div>
                                </td> -->

                                <td
                                    style="width: 13%"
                                    class="shipment-weight grayed"
                                    :id="`weight-${shipment.id}`"
                                    @click="editMode('weight', shipment.id)"
                                >
                                    <div v-show="shipment.measurement">
                                        <div
                                            class="dimension-marker tooltip-ex"
                                        >
                                            {{ $t("Weight") }}
                                        </div>
                                        <div
                                            style="width: 100%"
                                            v-if="shipment.weight != 0"
                                            class="arial-bold"
                                        >
                                            {{ shipment.weight }}
                                            {{
                                                shipment.measurement == "metric"
                                                    ? $t("kg")
                                                    : $t("lb")
                                            }}
                                        </div>
                                        <div
                                            v-else
                                            class="missing-data"
                                            style="
                                                width: 100%;
                                                text-alight: center;
                                            "
                                        >
                                            {{ $t("Weight") }}
                                        </div>
                                        <div class="mini-editor">
                                            <input
                                                type="number"
                                                class="mini-editor-input"
                                                max="999"
                                                tabindex="0"
                                                :id="`weight-editor-${shipment.id}`"
                                                @blur="
                                                    closeEditor(
                                                        'weight',
                                                        shipment.id,
                                                        $event
                                                    )
                                                "
                                                @input="validate($event)"
                                                @focus="
                                                    tabFocus(
                                                        `weight-${shipment.id}`
                                                    )
                                                "
                                            />
                                        </div>
                                    </div>
                                </td>
                                <td
                                    style="width: 32%"
                                    class="dimensions grayed"
                                >
                                    <div v-show="shipment.measurement">
                                        <div
                                            class="dimension-marker tooltip-ex"
                                        >
                                            {{ $t("Dimensions") }}
                                            {{ $t("( option )") }}
                                        </div>
                                        <div
                                            class="editor-anchor"
                                            :id="`length-${shipment.id}`"
                                            @click="
                                                editMode('length', shipment.id)
                                            "
                                        >
                                            <div
                                                v-if="shipment.length != 0"
                                                class="arial-bold"
                                            >
                                                {{ shipment.length }}
                                                {{
                                                    shipment.measurement ==
                                                    "metric"
                                                        ? $t("cm")
                                                        : $t("in")
                                                }}
                                            </div>
                                            <div v-else>
                                                {{ $t("length") }}
                                            </div>
                                            <div class="mini-editor">
                                                <input
                                                    type="number"
                                                    class="mini-editor-input"
                                                    max="300"
                                                    tabindex="0"
                                                    :id="`length-editor-${shipment.id}`"
                                                    @blur="
                                                        closeEditor(
                                                            'length',
                                                            shipment.id,
                                                            $event
                                                        )
                                                    "
                                                    @input="validate($event)"
                                                    @focus="
                                                        tabFocus(
                                                            `length-${shipment.id}`
                                                        )
                                                    "
                                                />
                                            </div>
                                        </div>
                                        <span
                                            style="
                                                color: #818181;
                                                margin-left: 10px;
                                                margin-right: 5px;
                                                display: inline-block;
                                            "
                                            >x</span
                                        >
                                        <div
                                            class="editor-anchor"
                                            :id="`width-${shipment.id}`"
                                            @click="
                                                editMode('width', shipment.id)
                                            "
                                        >
                                            <div
                                                v-if="shipment.width != 0"
                                                class="arial-bold"
                                            >
                                                {{ shipment.width }}
                                                {{
                                                    shipment.measurement ==
                                                    "metric"
                                                        ? $t("cm")
                                                        : $t("in")
                                                }}
                                            </div>
                                            <div v-else>
                                                {{ $t("width") }}
                                            </div>
                                            <div class="mini-editor">
                                                <input
                                                    type="number"
                                                    class="mini-editor-input"
                                                    max="300"
                                                    tabindex="0"
                                                    :id="`width-editor-${shipment.id}`"
                                                    @blur="
                                                        closeEditor(
                                                            'width',
                                                            shipment.id,
                                                            $event
                                                        )
                                                    "
                                                    @input="validate($event)"
                                                    @focus="
                                                        tabFocus(
                                                            `width-${shipment.id}`
                                                        )
                                                    "
                                                />
                                            </div>
                                        </div>
                                        <span
                                            style="
                                                color: #818181;
                                                margin-right: 10px;
                                                margin-left: 5px;
                                                display: inline-block;
                                            "
                                            >x</span
                                        >
                                        <div
                                            class="editor-anchor"
                                            :id="`height-${shipment.id}`"
                                            @click="
                                                editMode('height', shipment.id)
                                            "
                                        >
                                            <div
                                                v-if="shipment.height != 0"
                                                class="arial-bold"
                                            >
                                                {{ shipment.height }}
                                                {{
                                                    shipment.measurement ==
                                                    "metric"
                                                        ? $t("cm")
                                                        : $t("in")
                                                }}
                                            </div>
                                            <div v-else>
                                                {{ $t("height") }}
                                            </div>
                                            <div class="mini-editor">
                                                <input
                                                    type="number"
                                                    class="mini-editor-input"
                                                    max="300"
                                                    tabindex="0"
                                                    :id="`height-editor-${shipment.id}`"
                                                    @blur="
                                                        closeEditor(
                                                            'height',
                                                            shipment.id,
                                                            $event
                                                        )
                                                    "
                                                    @input="validate($event)"
                                                    @focus="
                                                        tabFocus(
                                                            `height-${shipment.id}`
                                                        )
                                                    "
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </td>
                                <td
                                    class="shipment-count grayed"
                                    style="width: 15%"
                                >
                                    <div v-show="shipment.measurement">
                                        <div
                                            class="dimension-marker tooltip-ex"
                                        >
                                            {{ $t("No. of packages") }}
                                        </div>
                                        <div class="form2-units" id="b-select">
                                            <b-select
                                                :value="shipment.quantity"
                                                @input="
                                                    editQuantity(
                                                        shipment.id,
                                                        $event
                                                    )
                                                "
                                            >
                                                <option
                                                    v-for="(n, index) in 100"
                                                    :key="index"
                                                    :value="n"
                                                >
                                                    {{ n }}
                                                </option>
                                            </b-select>
                                        </div>
                                    </div>
                                </td>
                                <td
                                    class="shipment-total-weight grayed"
                                    style="width: 20%"
                                >
                                    <div
                                        class="delete"
                                        @click="deleteShipment(shipment.id)"
                                    ></div>
                                    <div v-show="shipment.measurement">
                                        <div style="font-size: 1.4em">
                                            <span class="arial-bold">
                                                {{
                                                    packWeight(
                                                        shipment.length,
                                                        shipment.width,
                                                        shipment.height,
                                                        shipment.weight,
                                                        shipment.quantity,
                                                        shipment.measurement,
                                                        shipment.id
                                                    ) | number("0,0.0")
                                                }}
                                                {{
                                                    shipment.measurement ==
                                                    "metric"
                                                        ? $t("kg")
                                                        : $t("lb")
                                                }}
                                            </span>
                                        </div>
                                        <div
                                            style="
                                                margin-top: -5px;
                                                font-weight: bold;
                                                font-size: 15px;
                                            "
                                        >
                                            {{ $t("Total packages weight") }}
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div v-if="!shipping.length && showErrors" class="error">
                    <p>
                        {{
                            $t(
                                "Please add here your Packages first before go to next step"
                            )
                        }}
                    </p>
                </div>

                <div class="buttons" style="justify-content: flex-end">
                    <div
                        class="opt"
                        style="width: 89%; display: flex; flex-wrap: wrap"
                    >
                        <template v-if="!showList">
                            <button
                                class="button is-outlined add-shipment-type"
                                @click="addShipment('box')"
                                ref="box"
                                v-show="getViewsForForm2 !== 'env'"
                            >
                                <span style="font-weight: bold">
                                    {{ $t("Add Parcel") }}
                                </span>
                                <!-- <span
                                    style="
                                            display:block
                                            color: #4d4d4d;
                                            font-size: 12px;
                                            margin: 0 5px
                                        "
                                    >({{ $t("Box, Bag, Flyer") }})</span
                                > -->
                            </button>
                            <!-- <button
                                class="button is-outlined add-shipment-type"
                                @click="addShipment('envelope')"
                                ref="env"
                                v-show="getViewsForForm2 != 'box&bag'"
                            >
                                <span style="font-weight: bold">
                                    {{ $t("Document") }}
                                </span>
                                <span
                                    style="
                                            display:block
                                            color: #4d4d4d;
                                            font-size: 12px;
                                            margin: 0 5px
                                        "
                                    >({{ $t("Paper work only") }})</span
                                >
                            </button> -->
                        </template>

                        <!-- <div style="display: flex; flex-wrap: wrap; align-items: center">
              <button
                class="button is-outlined add-shipment-type"
                @click="showList = !showList"
              >
                {{ $t("My list") }}
              </button>
              <div v-if="showList" style="width: 350px; padding: 0 25px">
                <b-field>
                  <b-select
                    @input="addPackage"
                    v-model="list_package_item"
                    :placeholder="$t('List of choices')"
                    expanded
                  >
                    <option v-for="(item, i) in filterdList" :key="i" :value="item">
                      {{ item.title }}
                    </option>
                  </b-select>
                </b-field>
              </div>
            </div> -->
                    </div>
                </div>
                <!-- <div v-show="useVolumetricWeight" class="hint">
          <div style="display: flex; justify-content: space-between; align-items: start">
            <h3 class="title" style="margin-bottom: 25px">
              {{ $t("Why has the final weight of my shipment increased?") }}
            </h3>

            <div class="delete" @click="showHint = false"></div>
          </div>

          <div class="container">
            <h5 style="font-size: 16px; font-weight: bold">
              {{
                $t(
                  "The final weight of the piece is calculated by taking the largest weight between (actual weight) and (volumetric weight), and here the difference between them will be clarified;"
                )
              }}
            </h5>
            <div class="w-calc">
              <p style="display: block">
                {{
                  $t(
                    "Example: We have a shipment consisting of one box and weighing 10 kg"
                  )
                }}
              </p>
              <p style="display: block">
                {{ $t("Box dimensions: length 70 cm, width 80 cm, and height 55 cm") }}
              </p>

              <p style="margin: 70px 0 20px">
                {{ $t("Actual weight") }} = 10 {{ $t("kg") }}
              </p>
              <div style="display: flex; align-items: center">
                <p>{{ $t("Volumetric weight") }} =</p>
                <div style="margin: 0 10px; text-align: center">
                  <p style="border-bottom: 4px solid #000">
                    {{ $t("length") }} x {{ $t("width") }} x
                    {{ $t("height") }}
                  </p>
                  <p>5000</p>
                </div>
                <p style="margin: 0 10px">=</p>
                <div style="margin: 0 10px; text-align: center">
                  <p style="border-bottom: 4px solid #000; direction: ltr">
                    55 x 80 x 70
                  </p>
                  <p>5000</p>
                </div>
                <p style="margin: 0 10px">=</p>
                <p>61.6 {{ $t("kg") }}</p>
              </div>

              <div class="container" style="margin-top: 40px">
                <h5
                  style="
                    font-size: 18px;
                    background: #50e3c275;
                    border-radius: 7px;
                    padding: 10px;
                    margin-bottom: 15px;
                    font-weight: bold;
                  "
                >
                  {{
                    $t(
                      "Now, the largest value between the actual and volumetric weight will be adopted, which is 61.6 kg"
                    )
                  }}
                </h5>
              </div>
            </div>
          </div>

          <div class="container" style="margin-top: 30px">
            <div>
              <p style="font-weight: bold">
                -
                {{
                  $t("Formula for calculating volumetric weight if the unit is (in / lb)")
                }}
              </p>
              <div class="w-calc v-weight">
                <p>{{ $t("Volumetric weight") }} =</p>
                <div style="text-align: center">
                  <p style="border-bottom: 4px solid #000">
                    {{ $t("length") }} x {{ $t("width") }} x
                    {{ $t("height") }}
                  </p>
                  <p>139</p>
                </div>
              </div>
            </div>
            <div style="margin-top: 20px">
              <p style="font-weight: bold">
                -
                {{
                  $t("Formula for calculating volumetric weight if the unit is (cm / kg)")
                }}
              </p>
              <div class="w-calc v-weight">
                <p>{{ $t("Volumetric weight") }} =</p>
                <div style="text-align: center">
                  <p style="border-bottom: 4px solid #000">
                    {{ $t("length") }} x {{ $t("width") }} x
                    {{ $t("height") }}
                  </p>
                  <p>5000</p>
                </div>
              </div>
            </div>
          </div>
        </div> -->

                <div class="total_weight" v-if="totalWeight > 0">
                    <div class="parent">
                        <div
                            style="
                                color: #000;
                                font-size: 2.8em;
                                font-weight: bold;
                                height: 4rem;
                            "
                        >
                            <p style="padding: 0">
                                <span>{{ totalWeight | number("0,0.0") }}</span>
                                <span style="padding: 0 5px">{{
                                    $t("kg")
                                }}</span>
                            </p>
                        </div>
                        <!-- <p style="width: 100%">
              <span>{{ (totalWeight * 2.2) | number("0,0.0") }}</span>
              <span style="padding: 0 5px">{{ $t("lb") }}</span>
            </p> -->
                        <span style="font-size: 1.3em">{{
                            $t("Final shipment weight")
                        }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { globalEvent } from "@/main";

export default {
    data() {
        return {
            list_package_item: null,
            changed: false,
            haveErrors: false,
            isOpen: true,
            showEnvelope: true,
            showBox_Bags: true,
            showErrors: false,
            showList: false,
            filterdList: [],
            useVolumetricWeight: false,
        };
    },
    watch: {
        shipping: {
            immediate: true,
            deep: true,
            handler(val) {
                let error = 0;
                if (val.length == 0) {
                    this.$emit("finish", false);
                    return;
                }

                val.map((p) => {
                    Object.keys(p).map((key) => {
                        // let obj = {
                        //   height: 0,
                        //   id: 1,
                        //   length: 0,
                        //   measurement: "",
                        //   quantity: 1,
                        //   total_weight: 0,
                        //   type: "box",
                        //   weight: 0,
                        //   width: 0,
                        // };
                        // if (obj[key] === undefined) return;
                        if (
                            ![
                                "id",
                                "height",
                                "length",
                                "width",
                                "total_weight",
                            ].includes(key)
                        ) {
                            if (p[key] == 0 || p[key] == "" || p[key] == null) {
                                error++;
                            }
                        }
                    });
                });

                if (error == 0) {
                    this.$emit("finish", true);
                    return true;
                } else {
                    this.$emit("finish", false);
                    return false;
                }
            },
        },
        getViewsForForm2: {
            immediate: true,
            handler(val) {
                this.filterList();
            },
        },
        packages_list: {
            immediate: true,
            handler(val) {
                this.filterList();
            },
        },
    },
    methods: {
        filterList() {
            if (!this.getViewsForForm2) {
                this.filterdList = this.packages_list;
                return;
            }
            if (this.getViewsForForm2 == "env") {
                this.filterdList = this.packages_list.filter((list) =>
                    list.title.includes("env")
                );
            } else if (this.getViewsForForm2 == "box&bag") {
                this.filterdList = this.packages_list.filter(
                    (list) => !list.title.includes("env")
                );
            }
        },
        addPackage() {
            this.showErrors = false;
            this.showList = false;

            this.$store.dispatch("addShipmentItem", this.list_package_item);

            if (this.list_package_item.title.includes("envelope")) {
                this.list_package_item = null;
                this.$store.dispatch("handleViewForm2", "env");
            } else {
                this.list_package_item = null;
                this.$store.dispatch("handleViewForm2", "box&bag");
            }
            this.changed = true;
            this.haveErrors = false;
        },
        saveInList(shipment) {
            this.$store.dispatch("SAVE_IN_LIST", shipment).then((res) => {
                this.$buefy.toast.open({
                    message: this.$t("Added to your list"),
                    type: "is-primary",
                });
            });
        },
        checkInMyList(shipment) {
            let title = `${shipment.type == "box" ? "parcel" : shipment.type} ${
                shipment.weight
            }${shipment.measurement == "metric" ? "kg" : "lb"} | ${
                shipment.width
            } x ${shipment.length} x ${shipment.height} ${
                shipment.measurement == "metric" ? "cm" : "in"
            }`;

            let check = this.packages_list.filter((p) => p.title == title);
            if (check.length) return false;
            return true;
        },
        showAllError() {
            let items = null;
            this.showErrors = true;

            items = document.getElementsByClassName("missing-data");
            items[0].closest(".item").scrollIntoView({
                behavior: "smooth",
            });
        },
        hideForm() {
            this.$el.classList.add("hide-form-container");
        },
        packageUnit() {
            this.$store.dispatch("setPackageUnit", "metric");
        },
        tabFocus(n) {
            document.getElementById(n).classList.add("edit-mode");
        },
        addShipment(t) {
            this.showErrors = false;
            this.$store.dispatch("addShipment", t);
            if (t == "envelope") {
                this.$store.dispatch("handleViewForm2", "env");
            } else {
                this.$store.dispatch("handleViewForm2", "box&bag");
            }
            this.changed = true;
            this.haveErrors = false;
        },
        deleteShipment(id) {
            this.$store.dispatch("deleteShipment", id);
            if (this.shipping.length == 0) {
                this.$store.dispatch("handleViewForm2", null);
            }
            this.changed = true;
        },
        editMode(t, id) {
            document.getElementById(`${t}-${id}`).classList.add("edit-mode");
            document.getElementById(`${t}-editor-${id}`).focus();
        },
        closeEditor(t, id, e) {
            let str = e.target.value;
            if (str.charAt(str.length - 1) == ".") {
                e.target.value = str.slice(0, str.length - 1);
            }
            if (str.charAt(0) == "0") {
                e.target.value = str.slice(1);
            }
            document.getElementById(`${t}-${id}`).classList.remove("edit-mode");
            switch (t) {
                case "weight":
                    this.editWeight(
                        id,
                        document.getElementById(`${t}-editor-${id}`).value
                    );
                    break;

                case "length":
                    this.editLength(
                        id,
                        document.getElementById(`${t}-editor-${id}`).value
                    );
                    break;

                case "width":
                    this.editWidth(
                        id,
                        document.getElementById(`${t}-editor-${id}`).value
                    );
                    break;

                case "height":
                    this.editHeight(
                        id,
                        document.getElementById(`${t}-editor-${id}`).value
                    );
                    break;
            }
        },
        editQuantity(id, quantity) {
            this.$store.dispatch("editQuantity", {
                id: id,
                quantity: quantity,
            });
            this.changed = true;
        },
        editWeight(id, v) {
            this.$store.dispatch("editWeight", {
                id,
                v,
            });
            this.changed = true;
        },
        editLength(id, v) {
            this.$store.dispatch("editLength", {
                id,
                v,
            });
            this.changed = true;
        },
        editWidth(id, v) {
            this.$store.dispatch("editWidth", {
                id,
                v,
            });
            this.changed = true;
        },
        editHeight(id, v) {
            this.$store.dispatch("editHeight", {
                id,
                v,
            });
            this.changed = true;
        },
        validate(e) {
            let i = e.target.value;
            let valid = i.replace(/[^\d|.]/, "");
            let dot = valid.indexOf(".");
            if (dot == -1) {
                if (Number(valid) > 300) {
                    valid = String(valid).slice(0, 2);
                }
                e.target.value = valid;
            } else {
                if (dot == i.length - 1) {
                    if (Number(valid) > 300) {
                        valid = String(valid).slice(0, 2);
                    }
                    e.target.value = valid;
                } else {
                    let float = valid.slice(dot + 1);
                    if (float.length <= 2) {
                        e.target.value = `${valid.slice(
                            0,
                            dot + 1
                        )}${float.replace(/[^\d]/, "")}`;
                    } else {
                        e.target.value = `${valid.slice(
                            0,
                            dot + 1
                        )}${valid
                            .slice(dot + 1, (dot = 2))
                            .replace(/[^\d]/, "")}`;
                    }
                }
            }
        },
        allowNext() {
            let s = true;
            let { packages } = this.$store.state.shipment;
            if (packages.length == 0) {
                s = false;
            } else {
                packages.forEach((p) => {
                    if (p.height == 0) {
                        p.height = 1;
                    }
                    if (p.length == 0) {
                        p.length = 1;
                    }
                    if (p.width == 0) {
                        p.width = 1;
                    }
                    if (p.weight == 0) {
                        s = false;
                        return;
                    }
                    if (p.quantity < 1) {
                        s = false;
                        return;
                    }
                });
                if (!s) return s;
                this.$store.dispatch("finalWeight", this.totalWeight);
                this.getRates();
            }
            return s;
        },
        getRates() {
            globalEvent.$emit("loading", {
                status: true,
                message: "Getting the best rates",
            });
            this.$store
                .dispatch("rate", this.shipping)
                .then(() => {
                    globalEvent.$emit("renewError");
                    globalEvent.$emit("loading", false);
                })
                .catch((e) => {
                    globalEvent.$emit("loading", false);
                    globalEvent.$emit("message", {
                        type: "error",
                        message: e.data.response.data.message,
                    });
                    globalEvent.$emit("steps", 1);
                });
        },
        packWeight(l, w, h, weight, q, measurement, id) {
            let total = 0;
            if (measurement != "metric") {
                let b = weight * q;
                let c = ((l * w * h) / 139) * q;
                let a = b > c ? b : c;
                if (c > b) this.useVolumetricWeight = true;
                total = a;
            } else {
                let b = weight * q;
                let c = ((l * w * h) / 5000) * q;
                let a = b > c ? b : c;
                if (c > b) this.useVolumetricWeight = true;
                total = a;
            }
            this.$store.dispatch("editTotalWeight", {
                id,
                total,
            });
            return total.toFixed(1);
        },
    },
    created() {
        globalEvent.$on("haveErrors", () => {
            this.haveErrors = true;
        });
        globalEvent.$on("s1changed", () => {
            this.haveErrors = false;
        });
        this.$store.dispatch("GET_LIST");
    },
    mounted() {
        if (!this.shipping.length) {
            this.addShipment("box");
        }
        this.filterList();
        setTimeout(() => {
            this.isOpen = false;
        }, 3000);
    },
    computed: {
        packages_list() {
            return this.$store.getters.packages_list;
        },
        getViewsForForm2() {
            return this.$store.getters.getViewsForForm2;
        },
        totalWeight() {
            return this.$store.getters.totalWeight;
        },
        shipping() {
            return this.$store.getters.shipping;
        },
    },
};
</script>

<style lang="scss" scoped>
$primary: #686868;
$error: #eb6174;
.final-res {
    h3 {
        font-size: 24px;
    }
}

.w-calc {
    font-size: 18px;
    width: 70%;
    font-weight: bold;
    background: #e3e3e3;
    padding: 20px;
    border-radius: 7px;
    margin-top: 10px;

    &.v-weight {
        display: flex;
        align-items: center;
        justify-content: center;
        p {
            padding: 0 20px;
        }
        div {
            p {
                padding: 5px;
                font-size: 20px;
            }
        }
    }
    span {
        padding: 4px;
    }
}
.title {
    font-size: 24px;
    margin-bottom: 8px;
    margin-right: 14px;
    font-weight: bold;
    opacity: 0.8;
}

.hint {
    background: #f7f7f7;
    margin: 0 10px;
    padding: 5px 15px;
    color: #000;
    border-radius: 7px;
    display: inline-block;
}

.error {
    margin: 20px 0;
    padding: 20px 0;
    background: #f7f7f7;
    color: $error;
    border-radius: 15px;

    p {
        text-align: center;
    }
}

.missing-data {
    color: #ff7977 !important;
    border: 1px solid #ff7977 !important;
    border-radius: 4px;
}

.total_weight {
    text-align: right;
    direction: ltr;

    .parent {
        display: block;
        text-align: left;
        width: 206px;
        float: right;

        p {
            font-size: 0.9em;
        }
    }
}

.tooltip-ex {
    &::after {
        content: "!";
        position: absolute;
        display: inline-block;
        border: 1px solid #4f4f4f;
        border-radius: 50%;
        width: 15px;
        height: 16px;
        font-size: 12px;
        top: 3px;
        margin: 3px;
        text-align: center;
    }
}

.rounded-7 {
    border-radius: 7px;
}

.px-15 {
    padding: 0 15px;
}

.shipment-total-weight.grayed {
    position: relative;

    .delete {
        position: absolute;
        top: 0;
        right: 0;
        border-radius: 4px;
        padding: 13px;
        background: none !important;

        &::after {
            background: #686868 !important;

            .modal-close::after {
                height: 65%;
            }
        }

        &::before {
            background: #686868 !important;

            .modal-close::after {
                height: 65%;
            }
        }
    }
}

.form-container {
    padding: 1.5rem 1.5rem 0 1.5rem;
    box-sizing: inherit;
    transition: 0.4s ease-out;
    opacity: 1;

    .buttons {
        button {
            margin: 0 0.5rem;
            min-width: 150px;
        }
    }

    .add-shipment-type {
        transition: 0.25s linear;
        opacity: 1;
        margin: 5px !important;
    }

    .add-shipment-type.hide-button {
        opacity: 0;
    }

    #form-title-top {
        display: inline-block;
        font-size: 25px;
    }

    .is-full {
        padding-top: 0;

        .contents {
            margin: 20px 0;
        }

        button {
            padding: 0 15px;
            border-radius: 7px;
        }
    }

    .table {
        width: 100%;

        .oversizeMsg {
            position: absolute;
            bottom: 3px;
            font-size: 12px;
            left: 35%;
            z-index: 10;

            .msg {
                background: #ff7977;
                padding: 1px 15px;
                margin: 5px 0;
                border-radius: 5px;
                color: #000;
            }
        }

        div {
            text-align: center;
        }

        tr {
            position: relative;
            display: block;
            min-width: 100%;
            margin-bottom: 15px;

            td {
                padding-bottom: 15px;
                min-width: 60px;
                text-align: center;
            }

            td:not(.dimensions) {
                min-width: 40px;
                text-align: center;
                cursor: pointer;
                position: relative;
                transition: 0.25s linear;
                color: #818181;
                font-size: 1rem;

                .dimension-marker {
                    color: #686868;
                    border-bottom: 1px solid #818181;
                    font-size: 0.95rem;
                    margin: 7px 0;
                    width: 100%;
                }

                .mini-editor {
                    transition: 0.25s linear;
                    position: absolute;
                    width: 100%;
                    height: 28%;
                    padding: 2px;
                    z-index: -1;
                    top: 40px;
                    left: 0;

                    input {
                        width: 100%;
                        height: 130%;
                        border: none;
                        outline: none;
                        background-color: #f2f2f2;
                        text-align: center;
                        font-weight: bold;
                        font-size: 1.2rem;
                        color: #818181;
                    }
                }
            }

            td.dimensions {
                min-width: 250px;
                text-align: center;
                position: relative;

                .dimension-marker {
                    color: #818181;
                    border-bottom: 1px solid #818181;
                    font-size: 0.95rem;
                    margin: 7px 15px;
                }

                .editor-anchor {
                    width: 25%;
                    text-align: center;
                    cursor: pointer;
                    position: relative;
                    transition: 0.25s linear;
                    display: inline-block;
                    color: #818181;
                    font-size: 1rem;

                    .mini-editor {
                        transition: 0.25s linear;
                        position: absolute;
                        width: 100%;
                        height: 100%;
                        padding: 2px;
                        z-index: -1;
                        top: 0;
                        left: 0;

                        input {
                            font-size: 1rem;
                            width: 100%;
                            height: 100%;
                            border: none;
                            outline: none;
                            background-color: #f2f2f2;
                            text-align: center;
                            font-weight: bold;
                            color: #818181;
                        }
                    }
                }
            }

            td.edit-mode .mini-editor {
                z-index: 20;
            }

            td.dimensions .editor-anchor.edit-mode .mini-editor {
                z-index: 20;
            }

            td.grayed {
                background-color: #f2f2f2;
            }

            td.shipment-weight {
                width: 100px;
            }
        }

        .shipment-type {
            border-bottom: none !important;
            text-transform: capitalize;
            padding-top: 18px;
            text-align: center !important;

            @media screen and (max-width: 1150px) {
                text-align: left !important;

                &:lang(ar) {
                    text-align: right !important;
                }
            }

            .tag {
                width: 100px;
            }
        }

        .shipment-count {
            width: 150px;
            font-size: 1.2em;
            padding-top: 8px;

            span.arial-bold {
                width: 45px;
                display: inline-block;
            }
        }

        .shipment-total-weight {
            width: 120px;
        }
    }

    #weight-dimension-instructions {
        background-color: #f7f7f7;
        color: black;
        border-radius: 25px;
        height: 100%;
        width: 100%;

        .instructions {
            display: flex;
            align-items: center;
        }

        p {
            text-align: left;
            font-size: 2rem;
            font-weight: bold;
            padding: 20px;
        }

        a {
            color: #555;
            font-weight: bold;
            text-decoration: underline;

            &:hover {
                color: black;
            }
        }

        button {
            background: none;
            color: black;
            height: 27px;
            font-size: 14px;
        }

        .instruction-body {
            padding: 15px 25px;
            text-align: left;
        }
    }
}

@media screen and (max-width: 1150px) {
    table {
        tr {
            flex-wrap: wrap !important;
        }

        td {
            font-size: 16px !important;

            &.shipment-type {
                width: 100% !important;
                display: flex !important;
                align-items: flex-end !important;
                justify-content: space-between !important;
                padding-bottom: 5px !important;
                font-size: 14px !important;
            }

            &.shipment-units,
            &.shipment-count,
            &.shipment-weight {
                width: 20% !important;

                select {
                    font-size: 14px !important;
                }
            }

            &.dimensions {
                width: 40% !important;
            }

            &.shipment-total-weight {
                width: 100% !important;

                div {
                    font-size: 18px !important;
                }
            }
        }
    }
}

@media screen and (max-width: 770px) {
    .w-calc {
        width: 100%;
    }
    table {
        td {
            font-size: 16px !important;

            &.shipment-type {
                width: 100% !important;
                display: flex !important;
                align-items: flex-end !important;
                justify-content: space-between !important;
                padding-bottom: 5px !important;
                font-size: 14px !important;
            }

            &.shipment-units,
            &.shipment-weight {
                width: 50% !important;

                select {
                    font-size: 14px !important;
                }
            }

            &.shipment-count {
                width: 100% !important;
            }

            &.dimensions {
                width: 100% !important;
            }

            &.shipment-total-weight {
                width: 100% !important;

                div {
                    font-size: 18px !important;
                }
            }
        }
    }

    .total_weight .parent {
        float: none !important;
    }

    .buttons .opt {
        width: 100% !important;
    }
}
</style>
